import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import CardUnitJadwal from "../../components/CardUnit/CardUnitJadwal";
import FilterJadwalLelang from "../../components/Filters/FilterJadwalLelang";
import DatePicker from "react-datepicker";
// import subDays from "date-fns/subDays";
// import addDays from "date-fns/addDays";
import "react-datepicker/dist/react-datepicker.css";
import "../../assets/css/component.css";
import withoutAuth from "../../services/withoutAuthProvider";
import { format } from "date-fns";

import MoreButton from "../../components/MoreButton/MoreButton";
import { useHistory } from "react-router-dom";
import { SkeletonJadwal } from "../../components/Skeleton/Skeleton";
import { actionsPage } from "../../redux/page.slice";
import { useDispatch, useSelector } from "react-redux";
import { subdomainSelector } from "../../redux/subdomain.slice";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useBalancedData } from "../../hooks/useStaleWhileRevalidate";
import toast from "react-hot-toast";

const initialPaginate = {
  page: 1,
  page_size: 12,
  total: 1,
  location_id: "",
  unit_type_id: "",
};

const CloseButton = () => (
  <svg
    style={{ marginLeft: "8px" }}
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.99999 4.05734L8.29999 0.757339L9.24266 1.70001L5.94266 5.00001L9.24266 8.30001L8.29999 9.24267L4.99999 5.94267L1.69999 9.24267L0.757324 8.30001L4.05732 5.00001L0.757324 1.70001L1.69999 0.757339L4.99999 4.05734Z"
      fill="#9AA2B1"
    />
  </svg>
);

export default function JadwalLelangMendatang() {
  const { push } = useHistory();
  // const [units, setUnits] = useState([]);
  const dispatch = useDispatch();
  const [paginate, setPaginate] = useState({ ...initialPaginate });
  // const [isLoading, setIsLoading] = useState(true);
  // const [locations, setLocations] = useState([]);
  // const [unitTypes, setUnitTypes] = useState([]);
  const [filters, setFilters] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const subdomain = useSelector(subdomainSelector);

  const resetFilter = () => {
    setPaginate({ ...initialPaginate });
    setFilters([]);
    setStartDate(new Date());
  };

  const removeFilter = (nameId) => {
    setFilters((prev) => prev.filter((el) => el.id !== nameId));
    if (nameId === "start_date") {
      setStartDate(new Date());
    }
  };

  const removeTag = (nameId) => {
    setPaginate((prev) => ({
      ...prev,
      [nameId]: "",
    }));
    removeFilter(nameId);
  };

  const setFilterTag = (nameId, newData = {}) => {
    const foundFilter = filters.find((filt) => filt.id === nameId);
    if (foundFilter) {
      setFilters((prev) =>
        prev.map((data) => ({
          ...data,
          name: data.id === nameId ? newData.name : data.name,
        }))
      );
    } else {
      setFilters((prev) => [
        ...prev,
        {
          id: nameId,
          name: newData.name,
        },
      ]);
    }
  };

  const changeDate = (date) => {
    const newData = {
      id: "start_date",
      name: format(date, "dd MMM yyyy"),
    };
    setStartDate(date);
    setFilterTag("start_date", newData);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPaginate((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (value !== "") {
      const myArr = name === "location_id" ? [...locations] : [...unitTypes];
      const foundData = myArr.find((el) => el.id === parseInt(value));
      setFilterTag(name, foundData);
    } else {
      removeFilter(name);
    }
  };

  // Filters UseQuery - Cache 5 menit sesuai Cache Duration.md
  const { data: locations = [] } = useBalancedData(
    ["locations"],
    async () => {
      const response = await withoutAuth.getDataWithoutAuth("/api/location", {});
      return response?.status === 200 ? response.data.data.data : [];
    },
    { cacheTime: 1000 * 60 * 5 } // 5 menit
  );

  const { data: unitTypes = [] } = useBalancedData(
    ["unitTypes"],
    async () => {
      const response = await withoutAuth.getDataWithoutAuth("/api/unit-type", {});
      return response?.status === 200 ? response.data.data.data : [];
    },
    { cacheTime: 1000 * 60 * 5 } // 5 menit
  );

  // Main Data UseInfiniteQuery - Cache 5 menit sesuai Cache Duration.md
  const formattedDate = format(startDate, "yyyy-MM-dd");
  const hasDateFilter = filters.some((el) => el.id === "start_date");

  const { data, fetchNextPage, hasNextPage, isLoading, isFetchingNextPage } = useInfiniteQuery(
    ["jadwalLelangMendatang", paginate.location_id, paginate.unit_type_id, subdomain, formattedDate, hasDateFilter],
    async ({ pageParam = 1 }) => {
      const params = {
        page: pageParam,
        page_size: paginate.page_size,
        start_date: formattedDate,
        status: "COMING",
      };

      if (hasDateFilter) {
        params.end_date = formattedDate;
      }

      if (paginate.location_id !== "") {
        params.location_id = paginate.location_id;
      }
      if (paginate.unit_type_id !== "") {
        params.unit_type_id = paginate.unit_type_id;
      }
      if (subdomain !== "global") {
        params.exclusive_seller_slug = subdomain;
      }

      const response = await withoutAuth.getDataWithoutAuth("/api/auction", params);
      if (response?.status === 200) {
        return response.data.data;
      }
      throw new Error(response?.data?.message || "Failed to fetch schedules");
    },
    {
      cacheTime: 1000 * 60 * 5, // 5 menit sesuai Cache Duration.md
      staleTime: 0,
      getNextPageParam: (lastPage) => {
        if (lastPage.current_page < lastPage.last_page) {
          return lastPage.current_page + 1;
        }
        return undefined;
      },
      keepPreviousData: true,
      onError: (err) => {
        toast.error(err.message);
      },
    }
  );

  const units = React.useMemo(() => {
    return data?.pages?.flatMap((page) => page.data) || [];
  }, [data]);

  return (
    <div className="jadwalLelang">
      <div>
        <Container>
          <Row>
            <Col md={{ span: 4 }}>
              <div className="w-100 d-flex justify-content-center">
                <DatePicker
                  selected={startDate}
                  // highlightDates={highlightWithRanges}
                  onChange={(date) => changeDate(date)}
                  inline
                />
              </div>
            </Col>
            <Col md={{ span: 8 }}>
              <FilterJadwalLelang
                data={paginate}
                locations={locations}
                unitTypes={unitTypes}
                handleChange={handleChange}
              />
              <div className={filters.length > 0 ? "tag-filter-jadwal" : "d-none"}>
                <span
                  className="fw-bold text-primary cursor-pointer disable-copy"
                  onClick={resetFilter}
                  style={{ padding: "8px" }}
                >
                  Hapus Semua
                </span>
                {filters.map((filter, idx) => (
                  <span className="tag disable-copy" key={idx}>
                    {filter.name}
                    <span className="cursor-pointer" onClick={() => removeTag(filter.id)}>
                      <CloseButton />
                    </span>
                  </span>
                ))}
              </div>
              <div className="row" style={{ marginBottom: "16px" }}>
                {isLoading ? (
                  new Array(8).fill(1).map((el, idx) => (
                    <div className="col-6 col-md-4 col-xl-3 mb-4" key={`skeleton jadwal-${idx}`}>
                      <SkeletonJadwal />
                    </div>
                  ))
                ) : units.length > 0 ? (
                  units.map((el, index) => (
                    <div className="col-6 col-md-4 col-xl-3 mb-4" key={"b" + index}>
                      <CardUnitJadwal
                        auctionCategory={el?.auction_category}
                        tanggalAkhir={el?.date_finish}
                        id={el?.id}
                        judul={el?.name || "-"}
                        tanggal={el?.date_start}
                        waktu={`${el?.time_start?.substr(0, 5)} - ${el?.time_finish?.substr(0, 5)} WIB`}
                        lokasi={el?.location?.name || "-"}
                        live={el?.is_started}
                        onClick={() => {
                          if (el?.is_exclusive && subdomain === "global") {
                            window.open(
                              "https://" + el?.exclusive_seller_slug + "." + window.location.hostname + "/unit-lelang"
                            );
                          } else {
                            dispatch(actionsPage.setPage({ page: 0 }));
                            push("/unit-lelang", {
                              dataFilter: {
                                auction_id: el?.id,
                                unit_type_id: el?.unit_type?.id,
                                isTimeBid: el?.auction_category === "TIME-BID",
                              },
                            });
                          }
                        }}
                        unit_type_image={el?.unit_type?.banner_url}
                      />
                    </div>
                  ))
                ) : (
                  <div className="text-secondary text-center mt-5">Tidak ada jadwal lelang</div>
                )}
              </div>
              {hasNextPage && <MoreButton onClick={fetchNextPage} loading={isFetchingNextPage} />}
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}
